module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/heart-fddeee65752c362c6dcc86f7ed908898.svg";